// @flow

import _ from 'lodash';

import { addTruthyParamsToUrl, stripTrailingSlash } from '@zapier/url-utils';

import * as Profile from 'app/entities/Profile';
import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { getIdentity } from 'app/common/utils/IdentityUtils';

export const type = 'ssoIdentity';

const identity = getIdentity();

export const api = buildEntityApi(type, (path, getState) => {
  const profileId = Profile.selectors.all.currentProfileId(getState());
  return addTruthyParamsToUrl(
    stripTrailingSlash(`/api/v3/profiles/${profileId}/sso_identities/${path}`),
    {
      identity,
    }
  );
});

export const selectors = buildEntitySelectors(type, sel => {
  sel.provider = _.partial(sel.dataItem, 'provider');
  sel.email = _.partial(sel.dataItem, 'email');

  const hasProvider = (provider, entity) => sel.provider(entity) === provider;
  sel.all.findByProvider = _.partial(sel.all.findBy, hasProvider);
});

export const actions = buildEntityActions(type, selectors, api);
